export default __webpack_public_path__ + "static/media/movieNominator.fc895775.gif";